import { useGtmStore } from "@/plugins/pinia/gtm";

export function useGtmListeners(name: string, label: string) {
  const gtmStore = useGtmStore();

  function onFocus() {
    void gtmStore.registrationInteractionEvent({ name, label });
  }

  let previousError: string | null = null;

  function onValidationError({ error }: { error: string | null }) {
    if (previousError === error) {
      return;
    }

    previousError = error;

    if (error) {
      void gtmStore.registrationErrorEvent({
        name,
        label,
        error,
      });
    }
  }

  return {
    focus: onFocus,
    validationError: onValidationError,
  };
}
